{
  "id": "001-002",
  "title": "Resolving blockers",
  "layout": {
    "modifiers": [
      {
        "id": "0f262170",
        "type": "toggle"
      }
    ],
    "offset": "odd-row",
    "tiles": {
      "0": {
        "0": {
          "id": "04c7d967",
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 0
                },
                {
                  "color": "#ff0000",
                  "direction": 1
                },
                {
                  "color": "#0000ff",
                  "direction": 2,
                  "toggled": true
                },
                {
                  "color": "#ff0000",
                  "direction": 3
                },
                {
                  "color": "#0000ff",
                  "direction": 4
                },
                {
                  "color": "#ff0000",
                  "direction": 5,
                  "toggled": true
                }
              ],
              "id": "c5835edd"
            }
          ]
        },
        "1": {
          "id": "e0e00401",
          "type": "tile"
        },
        "2": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 5,
                  "toggled": false
                }
              ],
              "id": "d21e5308"
            }
          ],
          "id": "5acc1407"
        },
        "-1": {
          "id": "6c632460",
          "type": "tile"
        },
        "-2": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#ff0000",
                  "direction": 2,
                  "toggled": false
                }
              ],
              "id": "fb669389"
            }
          ],
          "id": "1652ec72"
        }
      },
      "1": {
        "0": {
          "type": "tile",
          "id": "d0b13fc4"
        },
        "1": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#008000",
                  "direction": 0,
                  "toggled": true
                }
              ],
              "id": "bbde184c"
            }
          ],
          "id": "453b4d64",
          "modifiers": [
            {
              "type": "immutable",
              "id": "b45a15d3"
            }
          ]
        },
        "-1": {
          "type": "tile",
          "id": "59e60928"
        },
        "-2": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#008000",
                  "direction": 1,
                  "toggled": false
                }
              ],
              "id": "c0ae2132"
            }
          ],
          "id": "e04bf3e8"
        }
      },
      "2": {
        "0": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#008000",
                  "direction": 0
                },
                {
                  "color": "#008000",
                  "direction": 1
                }
              ],
              "id": "98e62cb4"
            }
          ],
          "id": "1a2e1e12"
        },
        "1": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#ff0000",
                  "direction": 0,
                  "toggled": false
                }
              ],
              "id": "2eee79eb"
            }
          ],
          "id": "522b600d"
        },
        "-1": {
          "id": "ea370bb7",
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 1,
                  "toggled": false
                }
              ],
              "id": "b91484a6"
            }
          ]
        }
      },
      "-1": {
        "0": {
          "type": "tile",
          "id": "1848a6ad"
        },
        "1": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#008000",
                  "direction": 4,
                  "toggled": false
                }
              ],
              "id": "b7729e7f"
            }
          ],
          "id": "6a9d44bf"
        },
        "-1": {
          "id": "a7ae7f64",
          "type": "tile"
        },
        "-2": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#008000",
                  "direction": 3,
                  "toggled": true
                }
              ],
              "id": "996a54c9"
            }
          ],
          "id": "ee57363a",
          "modifiers": [
            {
              "type": "immutable",
              "id": "37e58227"
            }
          ]
        }
      },
      "-2": {
        "0": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#008000",
                  "direction": 4
                },
                {
                  "color": "#008000",
                  "direction": 3
                }
              ],
              "id": "5fff1412"
            }
          ],
          "id": "75667c33"
        },
        "1": {
          "id": "082207e9",
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#ff0000",
                  "direction": 4,
                  "toggled": false
                }
              ],
              "id": "f1aa8307"
            }
          ]
        },
        "-1": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 3,
                  "toggled": false
                }
              ],
              "id": "452cce64"
            }
          ],
          "id": "234b7936"
        }
      }
    }
  },
  "requirements": [
    {
      "type": "connections",
      "amount": 6
    }
  ],
  "version": 0
}
